import { curry, isEmpty, noop } from 'lodash';
import React from 'react';

import DealerLocatorContext from '../DealerLocatorContext';

export const clearSelectedDealer = (
  setContext,
  { toggleDetailView, onSelectDealer = noop },
) => () =>
  setContext({ selectedDealer: undefined }, () => {
    toggleDetailView && toggleDetailView();

    onSelectDealer(undefined);
  });

export const highlightDealer = curry((setContext, highlightedDealer) =>
  setContext({ highlightedDealer }),
);

export const selectDealer = curry(
  (
    setContext,
    { selectedDealer, toggleDetailView, onSelectDealer = noop },
    dealerId,
    index,
    location,
  ) =>
    setContext(
      { selectedDealer: { dealerId, index, location } },
      // The isEmpty check is for when the user is viewing a dealer detail
      // and chooses a different dealer on the map.
      () => {
        isEmpty(selectedDealer) && toggleDetailView && toggleDetailView();
        onSelectDealer({ dealerId, index, location });
      },
    ),
);

export const buildConsumerChild = curry(
  (WrappedComponent, componentProps, consumerProps) => {
    const {
      displayDetailView,
      toggleDetailView,
      updateDealerLocatorContext,
    } = consumerProps;

    return (
      <WrappedComponent
        {...componentProps}
        clearSelectedDealer={clearSelectedDealer(
          updateDealerLocatorContext,
          consumerProps,
        )}
        displayDetailView={displayDetailView}
        displayDetailViewEnabled={Boolean(toggleDetailView)}
        highlightDealer={highlightDealer(updateDealerLocatorContext)}
        selectDealer={selectDealer(updateDealerLocatorContext, consumerProps)}
      />
    );
  },
);

const withDealerActions = WrappedComponent => componentProps => (
  <DealerLocatorContext.Consumer>
    {buildConsumerChild(WrappedComponent, componentProps)}
  </DealerLocatorContext.Consumer>
);

export default withDealerActions;



// WEBPACK FOOTER //
// ./src/compositions/DealerLocator/withDealerActions/index.js